/**
 * Helper برای مدیریت مسیر تصاویر
 */

/**
 * دریافت مسیر کامل تصویر از public folder
 * @param {string} imagePath - مسیر تصویر نسبت به public folder (مثلاً '/images/logo.png')
 * @returns {string} - مسیر کامل تصویر
 */
export const getImagePath = (imagePath) => {
  // در development و production، فایل‌های public با / شروع می‌شوند
  // اما برای اطمینان از process.env.PUBLIC_URL استفاده می‌کنیم
  const publicUrl = process.env.PUBLIC_URL || '';
  return `${publicUrl}${imagePath}`;
};

/**
 * بررسی وجود تصویر
 * @param {string} imagePath - مسیر تصویر
 * @returns {Promise<boolean>} - true اگر تصویر وجود دارد
 */
export const checkImageExists = (imagePath) => {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => resolve(true);
    img.onerror = () => resolve(false);
    img.src = getImagePath(imagePath);
  });
};

